import React from "react";
import { FaSearch } from "react-icons/fa";

const SearchBar = ({ query, setQuery }) => {
  return (
    <div className="relative">
      <input
        type="text"
        placeholder="Search"
        className="w-full py-2 pl-10 border-2 border-blue-500 shadow-md focus:outline-none"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <div className="absolute top-[13.5px] left-3">
        <FaSearch className="text-blue-500" />
      </div>
    </div>
  );
};

export default SearchBar;
